import { Stack } from '@mui/material';

import { FC, ReactElement } from 'react';

export type HeadingWithTwoSizesProps = {
  largeHeading: ReactElement;
  smallHeading: ReactElement;
  headingLevel: number;
};

export const HeadingWithTwoSizes: FC<HeadingWithTwoSizesProps> = props => {
  return (
    <Stack aria-level={props.headingLevel} role='heading'>
      {props.smallHeading}
      {props.largeHeading}
    </Stack>
  );
};
